import React from 'react'
import PropTypes from 'prop-types'
import styled from 'react-emotion'

import { Flex } from 'shared/ui'

import InputWithDropdown from './InputWithDropdown'
import List from '../List'

const SingleOrMulti = props => {
  const {
    allowMultipleRecipients,
    onRemove,
    recipients,
    sui,
    editing,
    type,
  } = props

  if (!allowMultipleRecipients) return <InputWithDropdown {...props} />

  return (
    <List
      className="recipients_list"
      focused={editing}
      onRemove={onRemove}
      recipients={recipients}
      sui={sui}
      type={type}
    >
      <InputWithDropdown {...props} />
    </List>
  )
}

// eslint-disable-next-line react/no-multi-comp
const RecipientSearch = ({ className, ...rest }) => {
  return (
    <div className={className} tabIndex="-1">
      <div className={'row_content'}>
        <Flex className={'recipients'}>
          <SingleOrMulti {...rest} />
        </Flex>
      </div>
    </div>
  )
}

RecipientSearch.propTypes = {
  /* assumes contacts are to be added by name, if it doesnt pass email validation */
  allowCreateNewContactByName: PropTypes.bool,

  // Allow mutiple recipients (enabled by default)
  allowMultipleRecipients: PropTypes.bool,

  // override for our bloody SUI override.
  bgColor: PropTypes.string, // eslint-disable-line react/no-unused-prop-types

  /** Called when a recipient is selected. */
  onAdd: PropTypes.func,

  /** Called when a recipient is removed. */
  onRemove: PropTypes.func,

  /** Called after a To recipient is added (automatically by onAdd, but
   * documenting it here) */
  afterToAdd: PropTypes.func, // eslint-disable-line react/no-unused-prop-types

  /** Called when the input is blurred, CAVEAT: if this fn unmounts this
   * component, it will stop the dropdown menu items' onClick handler, so may
   * need to be debounced/cancelable.
   * */
  onBlur: PropTypes.func,

  /** Called when the input is focused. Can be used to cancel a pending
   * onBlur. */
  onFocus: PropTypes.func,

  // The initial list of recipients
  recipients: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types

  /** Triggers a parse & save on blur (not just enter/tab). Useful when used
   * in conjunction with allowCreateNewContactByName */
  saveOnBlur: PropTypes.bool,

  // Dont trigger onAdd
  skipOnAdd: PropTypes.bool,

  /* Used by the connected component */
  ticketId: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types

  // type of dropdown.
  type: PropTypes.oneOf(['to', 'cc', 'bcc']),

  // whether the search DD opens upward
  upward: PropTypes.bool,
}

RecipientSearch.defaultProps = {
  afterToAdd: undefined,
  bgColor: 'white',
  allowCreateNewContactByName: false,
  allowMultipleRecipients: true,
  onAdd: undefined,
  onBlur: undefined,
  onFocus: undefined,
  onRemove: undefined,
  skipOnAdd: false,
  saveOnBlur: false,
  type: undefined,
  upward: false,
}

export default styled(RecipientSearch)`
  flex-grow: 1;
  outline: 0;

  .row_content {
    display: flex;
    align-items: center;
  }

  .recipients {
    flex-grow: 1;
    flex-wrap: wrap;

    .sui.sui-transparent {
      flex-grow: 1;
      min-width: 0;
    }
  }

  &&& {
    .ui.dropdown > input:not(.search):first-child {
      /* override non 'search' SUI DDs that hide the input fields. Ideally we
     * should just move to standard SUI Search DDs. In the meantime, we need
     * this CSS override. */
      display: block !important;
    }
  }
`
